import {useEffect, useState} from "react";
import AddComponentContent from "./addComponent/AddComponentContent";
import ComponentList from "./ComponentList";
import ComponentsMenu from "./ComponentsMenu";
import {ElementStyles} from "../elements/ElementStyles";
import ComponentContentView from "./ComponentContentView";

export default function Component({onSave, onClose, editValues, tags, setTags}){
  const [routeStack, setRouteStack] = useState(["/"]);
  const [routeTopShort, setRouteTopShort] = useState("/");
  const [search, setSearch] = useState(null);
  const [component, setComponent] = useState(null);
  const [editValuesSave] = useState(editValues);
  useEffect(() => {
    setRouteTopShort(routeStack[routeStack.length - 1]);
  }, [routeStack]);

  useEffect(() => {
    if(editValues && editValues.id){
      setComponent(editValues);
      pushRoute("EDIT");
    }
  }, []);

  function pushRoute(route){
    setRouteStack((old) => [...old, route]);
  }

  function routeBack(){
    let tmp = [...routeStack];
    if(tmp.length === 1){
      return;
    }
    tmp.pop();
    setComponent(null);
    setRouteStack(tmp);
  }

  function getContent(){
    switch(routeTopShort){
      case "/":
        return (<ComponentsMenu close={onClose} pushRoute={pushRoute} setSearch={setSearch} tags={tags}/>);
      case "NEW":
        return (<AddComponentContent addComponent={onSave} setTagsOptions={setTags} tagsOptions={tags}/>);
      case "EDIT":
        return (<AddComponentContent editValue={editValuesSave} addComponent={onSave} setTagsOptions={setTags}
                                     tagsOptions={tags}/>);
      case "SAVED":
      case "SEARCH":
        return (<ComponentList routeTo={pushRoute} search={search} setComponent={setComponent}/>);
      default:
        if(component){
          if(component.description === "Personal Record"){
            return (<ComponentContentView component={component} tagsOptions={tags} title={
              component.name
            } addComponent={onSave}/>);
          }
          else{
            return (<AddComponentContent editValue={component} tagsOptions={tags} setTagsOptions={setTags}
                                         addComponent={onSave} viewComponent={true}/>);
          }
        }
        else{
          return (<ComponentList routeTo={pushRoute} search={search} setComponent={setComponent}/>);
        }
    }
  }

  const styles = {
    container: {
      borderRadius: ElementStyles.borderRadius,
      background: "var(--background)",
      color: ElementStyles.color,
      padding: "10px"
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", onKey);
    return window.removeEventListener("onkey", onKey);
  }, [routeStack]);

  function onKey(e){
    if(e.key === "ArrowLeft" && document.activeElement.id !== "textarea"){
      routeBack();
    }
  }

  return (<div style={styles.container}>
    {routeStack.length > 1 &&
      <div onClick={routeBack} style={{cursor: "pointer"}}>
        <div style={{display: "inline"}}>{"<-- "}</div>
        <div style={{display: "inline"}}>{routeStack[routeStack.length - 1].label}</div>
      </div>}
    {getContent()}
  </div>)
}